export default "assets/images/799a0177b0dc540682fa4a2e349a8f4f.png";